import { createAction } from "@reduxjs/toolkit";
import { reportCreatorActionTypes, reportPostActionTypes } from "./actionTypes";

export const reportCreator = createAction(
  reportCreatorActionTypes.request,
  (payload) => ({ payload }),
);

export const reportCreatorSuccess = createAction(
  reportCreatorActionTypes.success,
  (payload) => ({ payload }),
);

export const reportCreatorFailure = createAction(
  reportCreatorActionTypes.failure,
  (error) => ({ payload: error }),
);

export const reportPost = createAction(
  reportPostActionTypes.request,
  (payload) => ({ payload }),
);

export const reportPostSuccess = createAction(
  reportPostActionTypes.success,
  (payload) => ({ payload }),
);

export const reportPostFailure = createAction(
  reportPostActionTypes.failure,
  (error) => ({ payload: error }),
);

export const reportCreatorReset = createAction(reportCreatorActionTypes.reset);
export const reportPostReset = createAction(reportPostActionTypes.reset);
